import { render, staticRenderFns } from "./ActiveReservationBar.vue?vue&type=template&id=e888d122&lang=pug&"
import script from "./ActiveReservationBar.vue?vue&type=script&lang=ts&"
export * from "./ActiveReservationBar.vue?vue&type=script&lang=ts&"
import style0 from "./ActiveReservationBar.vue?vue&type=style&index=0&id=e888d122&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports